import { Flex, Stack, useDisclosure } from '@chakra-ui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Bleed, Button, Card, Menu, MenuItem, Tooltip } from '@main/complykit';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { useModal } from '@main/ui';
import { useUserData } from '@nhost/react';

import { CreateCustomProgramModal } from './create-custom-program';
import { CreateProgramFromTemplateModal } from './create-program-from-template';
import { ImportCsvDataType, ImportDataFromCsvModal } from './import-data-from-csv';
import { ProgramsTable } from './programs-table';

export const ProgramsTab = ({ orgId }: { orgId: string }) => {
  const { data: organizationData } = useGetOrganizationQuery({ orgId });
  const organization = organizationData?.organizations_by_pk;
  const { openModal } = useModal();
  const { isOpen: isImportOpen, onOpen: onImport, onClose: onCloseImport } = useDisclosure();
  const {
    isOpen: isImportAIControlOpen,
    onOpen: onImportAIControl,
    onClose: onCloseImportAIControl,
  } = useDisclosure();
  const user = useUserData();
  return (
    <Stack spacing={8}>
      <Card>
        <Bleed>
          <ProgramsTable orgId={orgId} />
        </Bleed>
      </Card>
      <Flex gap={2} alignSelf="end">
        <Tooltip
          content='Enable "Control AI review" for this organization'
          isDisabled={!!organization?.is_control_ai_review_enabled}
        >
          <Button
            variant="solid"
            isDisabled={!organization?.is_control_ai_review_enabled}
            onPress={onImportAIControl}
          >
            Import AI Criteria
          </Button>
        </Tooltip>

        <Menu
          placement="bottom-end"
          trigger={
            <Button variant="solid" iconEnd={ChevronDownIcon}>
              New program
            </Button>
          }
        >
          <MenuItem
            onAction={() =>
              openModal({
                header: 'Create program from template',
                size: 'xl',
                content: <CreateProgramFromTemplateModal orgId={orgId} />,
              })
            }
          >
            Create from template
          </MenuItem>
          <MenuItem
            onAction={() =>
              openModal({
                header: 'Create custom program',
                size: 'xl',
                content: <CreateCustomProgramModal orgId={orgId} />,
              })
            }
          >
            Create custom program
          </MenuItem>
          <MenuItem onAction={onImport}>Import from CSV</MenuItem>
        </Menu>
      </Flex>

      <ImportDataFromCsvModal
        key="import-control-ai-control-modal"
        importType={ImportCsvDataType.CONTROL_AI_CRITERIA}
        orgId={orgId}
        email={user?.email}
        isModalOpen={isImportAIControlOpen}
        onModalClose={onCloseImportAIControl}
      />

      <ImportDataFromCsvModal
        key="import-programs-modal"
        orgId={orgId}
        email={user?.email}
        isModalOpen={isImportOpen}
        onModalClose={onCloseImport}
        importType={ImportCsvDataType.PROGRAM}
      />
    </Stack>
  );
};
